export default __webpack_public_path__ + "static/media/notequal~yqtOJLJY.ecd2e841.svg";